export default __webpack_public_path__ + "img/stay-informed-with-alarms.08a00708.jpg";